<template>
    <div>
        <div :class="setCardClass(item.gradeType)" class="card-box">
            <div class="top">
                <div class="top-left">{{item.roleCodeName}}</div>
                <div class="top-right">
                    <span
                        :style="{'background': formattStatus(item.auditStatus,'color')}"
                        style="display:inline-block;;width: 6px;height: 6px; border-radius:50%;position: absolute;top: 4px;left: -10px;"
                    ></span>
                    <span>{{formattStatus(item.auditStatus,'status')}}</span>
                </div>
            </div>
            <div class="content">
                <div class="row">
                    <span>
                        <icon-svg name="user" class="icon-color"></icon-svg>
                    </span>
                    <span class="name">提交人</span>
                    <span class="value">{{item.auditorName|projectIsEmpty}}</span>
                </div>
                <div class="row">
                    <span>
                        <icon-svg name="createTime" class="icon-color"></icon-svg>
                    </span>
                    <span class="name">创建时间</span>
                    <span class="value">{{item.startTime|projectIsEmpty}}</span>
                </div>
                <div class="row">
                    <span>
                        <icon-svg name="submitTime" class="icon-color"></icon-svg>
                    </span>
                    <span class="name">提交时间</span>
                    <span class="value">{{item.endTime|projectIsEmpty}}</span>
                </div>
            </div>
            <div class="bottom">
                <div
                    :style="{width:(Number(item.costTimes)/Number(item.limitTime*60)*100)+'%'}"
                    class="progress"
                    v-if="item.costTimes&&item.limitTime"
                ></div>
                <div :style="{'justify-content':item.limitTime?'flex':''}" class="progressTitle">
                    <div
                        :style="{'margin-left':item.progressValue,'margin-right':'10px'}"
                        v-if="item.costTimes"
                    >历时： {{formattSec(item.costTimes)}}</div>
                    <div v-if="item.limitTime">限时： {{item.limitTime}}分钟</div>
                </div>
            </div>
            <div class="bg">
                <img src="../../../../../assets/img/bgCard.png" alt />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["item"],
   methods:{
    setCardClass(type){
                switch (type) {
                    case 0:
                        return "cardGreen1";
                        break;
                    case 1:
                        return "cardYellow";
                        break;
                    case 2:
                        return "cardOrange";
                        break;
                    case 3:
                        return "cardRed";
                        break;
                    case '':
                    case undefined:
                        return "cardGray";
                        break;
                    default:
                        return "";
                        break;
                }
        },
        formattStatus(evalStatus, type) {
            if (type == "status") {
                switch (evalStatus) {
                    case -1:
                        return "已退回";
                        break;
                    case 0:
                        return "未备案";
                        break;
                    case 1:
                        return "已备案";
                        break;
                    default:
                        return "";
                        break;
                }
            }
            if (type == "color") {
                switch (evalStatus) {
                    case -1:
                        return "#F23030";
                        break;
                    case 0:
                        return "#FF9900";
                        break;
                    case 1:
                        return "#52C41A";
                        break;
                    default:
                        return "";
                        break;
                }
            }
        },
        formattSec(seconds) {
            let hour = parseInt(seconds / 3600);
            let min = parseInt(seconds / 60);
            let sec = parseInt(seconds % 60);
            let str = "";
            if (hour) str += hour + "时";
            if (min) str += min + "分";
            if (sec) str += sec + "秒";
            return str;
        },
}
};
</script>

<style lang="scss" scoped>
.card-box {
    width: 304px;
    height: 156px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(72, 92, 109, 0.2);
    border-radius: 4px;
    border: 1px solid #f4f6fa;
    font-family: PingFangSC-Regular, PingFang SC;
    overflow: hidden;
    position: relative;
    .top {
        width: 100%;
        height: 36px;
        background: #eff3f6;
        border-radius: 2px 2px 0px 0px;
        padding: 0 16px;
        margin-bottom: 0px;
        display: flex;
        align-items: center;
        .top-left {
            font-size: 14px;
            font-weight: 500;
            color: #000000;
        }
        .top-right {
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            line-height: 12px;
            position: relative;
        }
    }
    .content {
        padding: 0 0 0 18px;
        height: calc(100% - 44px);
        .name,
        .icon-color {
            color: rgba($color: #000000, $alpha: 0.45);
        }
        .row {
            height: 28px;
            line-height: 28px;
            display: flex;
            align-items: center;
            .icon-color {
                margin-top: 9px;
            }
            .name {
                display: inline-block;
                width: 68px;
                margin-left: 4px;
                text-align: left;
            }
            .value {
                color: #7390ab;
            }
        }
    }
    .bottom {
        height: 8px;
        background: rgba(63, 191, 0, 0.25);
        position: relative;
        .progressTitle {
            width: 100%;
            position: absolute;
            top: -17px;
            font-size: 12px;
            display: flex;
            justify-content: space-between;
            & > div:nth-of-type(1) {
                margin-left: 10px;
            }
            & > div:nth-of-type(2) {
                margin-right: 10px;
            }
        }
        .progress {
            height: 100%;
        }
    }
    .bg {
        position: absolute;
        bottom: -23px;
        right: -15px;
    }
}
.cardGreen1 {
    .progressTitle div {
        color: #3fbf00;
    }
    .progress {
        background: #3fbf00;
    }
}
.cardRed {
    .top {
        background: rgba(242, 48, 48, 0.1);
    }
    .content {
        background: #fef0f0;
    }
    .bottom {
        background: #eff1f2;
    }
    .progressTitle div {
        color: #f23030;
    }
    .progress {
        background: #f23030;
    }
}
.cardYellow {
    .top {
        background: rgba(255, 153, 0, 0.1);
    }
    .bottom {
        background: #eff1f2;
    }
    .progressTitle div {
        color: #ffc500;
    }
    .progress {
        background: #ffc500;
    }
}
.cardOrange {
    .top {
        background: rgba(255, 153, 0, 0.1);
    }
    .bottom {
        background: #eff1f2;
    }
    .progressTitle div {
        color: #ff9900;
    }
    .progress {
        background: #ff9900;
    }
}
.cardGray {
    opacity: 0.4;
    .top .top-left {
        color: rgba(0, 0, 0, 0.45);
    }
    .top,
    .content,
    .bottom {
        background: rgba(0, 0, 0, 0.04);
    }
}
.cardGray + .line {
    background: rgba(0, 0, 0, 0.04);
}
.cardGray + .line > div {
    border-color: rgba(0, 0, 0, 0.04);
}
</style>